import moment from 'moment';


export function getDayPart(value){
    //1972-12-30
    if( (value !='') && (value != null)){
        let str = value;

        return str.slice(-2);
    }

}

export function getMonthPart(value){
    //1972-12-30
    if(  (value !='') && (value != null)){
        let str = value;

        return str.slice(5,7);
    }
}

export function getYearPart(value){
    //1972-12-30
    if(  (value !='') && (value != null)){
        let str = value;

        return str.slice(0, 4);
    }
}

export function getDateYYYYMMDD(value){
    //1972-12-30
    if(  (value !='') && (value != null)){

        return moment(value).format("YYYY-MM-DD");
    }
}

export function getDateDDMMYYYY(value){
    //1972-12-30
    if(  (value !='') && (value != null)){

        return moment(value).format("DD-MM-YYYY");
    }
}

export function getBillingCancelationDate(){
    let currentDate = moment();
    let currentDay = Number(currentDate.format("DD"));

    if(currentDay <= 15){
        return currentDate.format("DD MMMM YYYY");
    }else{

        let x = currentDate.add('1', 'months');

        return '15 ' + x.format("MMMM YYYY");
    }
}

export function getStringToDate(value){
    if(  (value !='') && (value != null)){

        return moment(value).toDate();
    }
}

/**
 * Get current date
 * @param format : 'YYYY-MM-DD'
 * @returns date
 */
export function getCurrentDate(format){
    let date = moment();
    return  date.format(format);
}

/**
 *
 * @param string str
 * @returns string
 */
export function fnReplace(str){
    const newString = str.toString().replace('[', '').replace(']', '');

    return newString;
}


/**
 * Get status name
 * @param int statusId
 * @return string
 */
export function fnGetStatusName(statusId){
    let strStatus ='';
    switch(Number(statusId)) {
        case 1:
          strStatus = "Draft";
          break;
        case 2:
          strStatus = "Submitted";
          break;
        case 3:
            strStatus = "Amended";
            break;
        case 4:
            strStatus = "Processing";
            break;
        case 5:
            strStatus = "Approved";
            break;
        case 6:
            strStatus = "Settled";
            break;
        case 7:
            strStatus = "Archived";
            break;
        case 8:
            strStatus = "Can not assist";
            break;
        case 9:
            strStatus = "Doc's To Client";
            break;
        case 10:
            strStatus = "Doc's To Employer";
            break;
        case 11:
            strStatus = "Doc's to Settlement";
            break;
        case 12:
            strStatus = "Pending Delivery";
            break;
        case 13:
            strStatus = "Pending Application";
            break;
        case 14:
            strStatus = "Preparing Docs";
            break;
        case 21:
            strStatus = "Leads (Draft)";
            break;
        case 22:
            strStatus = "Lead quoted";
            break;
        case 23:
            strStatus = "Submitted";
            break;
        case 24:
            strStatus = "Can not Assist";
            break;
        case 25:
            strStatus = "LMTCB";
            break;
        case 26:
            strStatus = "Infor. Only";
            break;
        case 29:
            strStatus = "Archived";
            break;
        case 30:
            strStatus = "Request DOCs for App";
            break;
        case 31:
            strStatus = "Booked Info Session";
            break;
        default:
          strStatus = "";
    }

    return strStatus;
}

/**
 * String snake case to title case
 * Eg. next_followup_date to Next followup date
 * @param string str
 * @returns string
 */
export function fnSnakeToTitle(str) {
    let strSentence = (str.replace(/[_\s]+/g, ' '));

    return strSentence.replace(/^.{1}/g, strSentence[0].toUpperCase());
}


  /**
   * Get sub domain for source url
   * @param url string : url
   * @return string :subdomain or main domain
   */
  export function getSubDomain(url) {
    if (url == '' || url == null || url == undefined) {
      return ''
    }
    let colon = url.split(/[\/]+/)
    let getFirstDot = colon[1].split(/[.]/)

    if (getFirstDot[0] == 'www') {
      return getFirstDot[1]
    }
    return getFirstDot[0]
  }

  /**
   * Flattern
   */
  export function getFlattenObj(input) {
    let result = {}
    for (const key in input) {
      if (!input.hasOwnProperty(key)) {
        continue
      }
      if (typeof input[key] === 'object' && !Array.isArray(input[key])) {
        var subFlatObject = getFlattenObj(input[key])
        for (const subkey in subFlatObject) {
          result[key + '.' + subkey] = subFlatObject[subkey]
        }
      } else {
        result[key] = input[key]
      }
    }
    return result
  }
